const ApplicationName = 'Request Management';

const Links = Object.freeze({
    manage: 'View Your products & services',
    maximManageTileLink: 'Your products and services for maxim',
    trackRequest: 'track service requests',
    viewRequest: 'service requests list',
    viewOpenRequestList: 'View open request list',
    viewCloseRequestList: 'View close request list',
    viewOpenRequestSummary: 'View open service request item summary',
    viewCloseRequestSummary: 'View close service request item summary',
    viewRequestSummary: 'View summary of service request item',
    viewRequestUpdate: 'View update of service request item',
    viewCategoryItem: 'View request category item',
    viewCategoryStep: 'View request categories',
    viewReviewScreen: 'View Review Screen',
    newRequest: 'new-request',
    viewMyProductsAndServices: 'View My products and services',
    requestListOrderedByOnTrack: 'request list ordered by on track',
    requestListOrderedByOnHold: 'request list ordered by on hold',
    requestListOrderedByDelayed: 'request list ordered by delayed',
    submitButton: 'Submit Button',
    createNewContactButton: 'Create New Delivery Contact Button',
    referenceEdit: 'Customer Reference Edit clicked',
    referenceSave: 'Customer Reference Save clicked',
    referenceSaveSuccess: 'Customer Reference Save success',
    referenceSaveFailed: 'Customer Reference Save failed',
    customerReferenceAdded: 'Customer Reference Add',
    ngucPortal: 'NGUC portal link clicked',
    linkForCSCinCatalogueItems: 'csc product link clicked',
    getPrevStepTrackingId: (stepId: string) => `${stepId}`,
    getExitStepId: (stepId: string) => `${stepId}`,
    subscriptionsList: 'Device List',
    mobileDevicesTab: 'Mobile Devices tab for mdm',
    topTenAppsTab: 'Top Ten Apps tab for mdm',
    maximRequests: 'maxim-requests-form',
    faqLink: 'new dashboard card faq link',
    fncNoServiceNumberFormLink: `Clicked on Feature Network Change Form Link to navigate
    to no-service number form page.`,
    fncViewAll: 'Clicked on View All Feature Network Changes link',
    fncChangeId: 'Clicked on changeID',
    dashboardLink: 'Clicked on dashboard link',
    tryAgain: 'Clicked on try again link',
    ypsLandingPageGenericLinks: (linkName: string) =>
        `clicked on ${linkName} link from your products and services landing page`,
    ypsLandingPageProductFamilyItemLinks: (linkName: string, productFamilyName: string) =>
        `Clicked on ${linkName}:${productFamilyName}.`,
    newRequestsButtonListPage: (landingPageName: string) =>
        `Clicked New Request navigated to ${landingPageName} landing page`,
    ypsPageNavigationFromDashboard: (navigationThrough: string) =>
        `user clicked on ${navigationThrough} and navigated to your products and services landing page`,
    trackRequestButton: 'clicked on track request button',
    serviceTool: 'Click on service tool link',
    maximFastChangeDeacRefreshLink: 'user clicked on refresh link available on toast message to refresh the page.',
    backButtonOnFastChangeConfirmScreen:
    'user clicked on back button and navigated to previous form page from confirm deactivation screen',
    continueDeactivateScreen: (formType: string) =>
        `Clicked on continue button in ${formType} form`,
    ssmLink: 'Clicked on SSM link',
    mobilitySolutionsOption: 'clicked on mobility solutions option from dropdown on maxim form page',
    otherOption: 'clicked on other option from dropdown on maxim form page',
    continueToSupportEnquiry: 'clicked on continue button on maxim form page to navigate to support enquiry page',
    goToSupportEnquiryButton: 'Clicked on support enquiry button',
    continueLinkName: 'International: Continue',
    backToPreviousPage: 'Clicked Back button',
    serviceNumberSelected: 'Service number is selected',
    mobileNumberSelected: 'Mobile number is selected',
    cancelNewRequestForm: 'Clicked Cancel button/icon for new request form',
    cancelNewRequestFormModal: 'Clicked Cancel button/icon of confirmation modal for new request form',
    submitNewRequestForm: 'Clicked Submit button/icon for new request form',
    submitNewRequestFormModal: 'Clicked Submit button/icon of confirmation modal for new request form',
    searchEnterEventLink: (searchComponentLabel: string) => `Pressed Enter on ${searchComponentLabel}.`,
    searchCancelIconEventLink: (searchComponentLabel: string) => `Clicked on cancel icon of ${searchComponentLabel}.`,
    backToInitialSearch: 'Clicked on back to address lookup',
    advancedFormSearch: 'user navigate to advanced search form',
    redesignedDashboardLink: (linkName: string) => `clicked on ${linkName} link on redesigned yps dashboard tile`,
    redesignedtrackRequestsLink: 'clicked on track requests link on redesigned yps dashboard tile',
    redesignedcreateRequestButton: 'clicked on create request button on redesigned yps dashboard tile',
    redesignedHeaderClick: 'clicked on header link on redesigned yps dashboard tile',
    redesignedRequestHeaderClick: 'clicked on header link on redesigned request dashboard tile',
    redesignedRequestManageClick: 'clicked on managed button on redesigned request dashboard tile',
    srmUnifiedTrackListUserSelctedTab: (tabName: string) => `${tabName} tab`,
    trackingRequestsScrollToBottom: 'User scrolled to bottom',
    trackingRequestsNavigateToDetailsPage: 'Navigated to requests details page',
    paginatedRequestNavigationToDetailsPage: (serviceNumber) => `clicked on ${serviceNumber} to navigate to details page`,
    trackingRequestsSelectedTab: (tabName: string) => `Requests-${tabName} tab`,
    maximActivityDetailsPageNavigation: `M-Os-Navigated to activity details page`,
    maximActivityPageChange: (page: number) => `M-Os-Page changed to ${page}`,
    maximActivityPageSizeChange: (pageSize: number) => `M-Os-Page size changed to ${pageSize}`,
    maximActivitySortColumn: (column: string, order: string) => `M-Os-${column} ${order} sorting`,
    fncListPageChange: (page: number) => `FNCs-Page number changed to ${page}`,
    fncListPageSizeChange: (pageSize: number) => `FNCs-Page size changed to ${pageSize}`,
    companyDropdown: 'Clicked on company dropdown',
    multiEntity: (button: string) => `Clicked on ${button} button`,
    irMonthPassTryAgainLink: 'clicked on try again for add-ons on international roaming month pass catalogue',
    iddCatalogueTryAgainLink:
    'clicked on try again for add-ons on Add, modify or cancel an International Calls and SMS Pack catalogue',
    newTnowSuccessPageTryAgainLink: 'clicked on try again for new success page of tnow catalogue items',
    newTnowSuccessPageTrackRequestButton: 'clicked on track request for new success page',
    bddCatalogueTryAgainLink:
    'clicked on try again for Enable / disable Business Demand Data catalogue',
    newTnowSuccessPageNewRequestLink: 'clicked on new request button',
    acceleratorAddOnTryAgainLink: 'clicked on try again for add-ons on Enable / disable Accelerator add-on',
    plannedMaintenanceQuickFilterClick: 'Planned Maintenance quick filter click',
    manageDirectoryListingTryAgainLink: ' clicked on try again for directory-listing on manage directory listing catalogue',
    maximMobileAndOthersSearchBtn: 'clicked on maxim mobile and others search button',
    maximMobileAndOthersSearchEnterEventLink: 'pressed Enter on maxim mobile and others search',
    maximMobileAndOthersClearSearchBtn: 'clicked on maxim mobile and others clear search button',
    adaptiveMobilityServiceTermsLink: 'Clicked on Adaptive Mobility Service Terms link',
    pageChange: (pageNumber) => `clicked on ${pageNumber} from pagination options`,
    requestSearchButton: 'Clicked on requests search button',
    requestSearchEnterEventLink: 'Pressed Enter on request search',
    requestClearSearchButton: 'Clicked on requests clear search button',
    relatedOrderLink: (orderNumber: string) => `Clicked on ${orderNumber} related order`,
    networkReportsInt: 'NetworkReports:International',
    iPRouteandDNSInt: 'IPRouteandDNS:International',
    sdwanInt: 'SD-WAN:International',
    breadcrumbTelstraConnect: 'Clicked on Telstra Connect link from breadcrumb',
    breadcrumbYPS: 'Clicked on Your Products and Services link from breadcrumb'
});

const Components = Object.freeze({
    getNewRequestStepTrackingId: (stepId: string) => `New Request - ${stepId}`,
    viewCategoryItem: 'Clicked on request category item',
    viewCategoryStep: 'Clicked on request category',
    stepValidationSuccess: 'Clicked Next Button (validation success)',
    stepValidationFailure: 'Clicked Next Button (validation failure)',
    formValidationFailure: 'Clicked on Submit Button(validation failure)',
    formValidationSuccess: 'Clicked on Submit Button(validation success)',
    submitButton: 'Clicked on submit button',
    submitValidationSuccess: 'Submission success',
    submitSuccess: (source: string, categoryItemName: string) =>
        `${source} submission success for '${categoryItemName}'`,
    submitFailure: (source: string, categoryItemName: string) =>
        `${source} submission failed for '${categoryItemName}'`,
    newRequestForm: (source: string, categoryItemName: string) =>
        `${source} New request form for category '${categoryItemName}'`,
    submitValidationFailure: 'Submission failure',
    backButton: 'Back From - ',
    exitButton: 'Cancel request',
    viewOpenRequestItem: 'Click on open request item from Request List',
    viewCloseRequestItem: 'Click on close request item from Request List',
    SummaryTab: 'Click on Request Summary Tab',
    UpdatesTab: 'Click on Request Updates Tab',
    OpenTab: 'Click on Request Open Tab',
    ClosedTab: 'Click Request on Closed Tab',
    reviewScreenComponent: 'Review Screen',
    newRequest: 'Clicked on create new request button',
    postCommentInActivityLogs: 'post comment in activity logs',
    successfulPostCommentInActivityLogs: 'comment is posted successfully',
    failedPostCommentInActivityLogs: 'post comment request is failed',
    customerReference: 'Click on customer reference',
    modificationsLandingPage: 'Click on Your products & services',
    ServiceslistComponent: 'Subscriptions List',
    mdmDevicesComponent: 'DevicesComponent',
    TenancyDropDown: 'Click on tenancy dropdown',
    DashBoard : 'Click on DashBoard',
    filterButton: 'Click on Filter Button',
    applyfilterButton: 'Click on Apply Filter Button',
    clearfilterButton: 'Click on Clear Filter Button',
    viewDetailsSectionInSummeryPage: 'Clicked on details section button.',
    detailsSectionShowMoreLinkInSummeryPage: 'clicked on show more',
    detailsSectionShowLessLinkInSummeryPage: 'clicked on show less',
    maximSerivceRequestResponsePage: 'Maxim Service Request Submission Response Page',
    maximNewServiceRequestPage: 'Maxim New Service Requets Page',
    maximResubmitButton: 'Cliked on Resubmit Button',
    maximCreateNewRequestButton: 'Clicked on maxim service request submit button',
    macMobilityTNowLinkButton: 'Clicked on link button from Submission Response Page',
    maximLandingPage: 'maxim landing page',
    maximYourTelstraToolsButton: 'Clicked on maxim your telstra tools button',
    maximCSCManageButton: 'Clicked on manage link button for CSC product',
    maximMobilitySolutionsManageButton: 'Clicked on manage button for mobility solutions for maxim',
    maximOtherProductsNewRequestButton: 'Clicked on new request button for other products for maxim',
    maximFNCNewRequestButton: 'Clicked on new request button for FNC for maxim',
    maximNBNDiagonosticCTAButton: 'Clicked on CTA button for NBN on maxim',
    maximTryAgain: 'Clicked on try again button for mobility solutions for maxim',
    mobilePlansAndDevicesMaximPage: 'mobile plans and devices for maxim',
    breadCrumbforMobilePlansAndDevicesMaxim: 'clicked on your products and services breadcrumb for maxim page',
    manageForMobilePlansAndDevicesMaxim: 'clicked on new request for mobile plans and devices for maxim page',
    downloadAttachmentInSummaryPage: (attachmentID: string) =>
        `clicked on attachment id -${attachmentID} download link`,
    fncServiceListLandingPage: 'FNC Landing Page.',
    mobileServicesPage: 'Maxim mobile services page',
    mobileServicesContextMenuItemClick: (serviceId: string) =>
        `Clicked on ${serviceId} from maxim mobile services page context menu.`,
    fncServiceListCheckbox: (serviceId: string) =>
        `Clicked on checkBox serviceId -${serviceId} on FNC service list landing page.`,
    fncServiceListRequestType: (requestType: string) =>
        `Clicked on ${requestType} request type from drop-down context-menu.`,
    mobilityServiceListRequestType: (requestType: string) =>
        `Clicked on ${requestType} request type from drop-down context-menu in mobility services list table.`,
    fncBasicFormPage: 'FNC Basic Form Page.',
    fncSubmitButton: 'Clicked on submit button on fnc basic form page.',
    fncBackButton: 'Clicked on back button on fnc basic form page.',
    fncNoServiceNumberFormPageLoad: 'FNC no-service number form page load',
    fncShowMoreAssistiveTextPanels: 'Clicked on Show more link on fnc form page',
    fncShowLessAssistiveTextPanels: 'Clicked on Show less link on fnc form page',
    fncNoServiceNumberForm: 'FNC No-Service Number Form Page.',
    fncFNN: (serviceNumber) => `Entered FNN (service number): ${serviceNumber}`,
    fncChangeTypeClick: (changeType: string, count: number) => `Clicked on ${changeType} ${count} times`,
    fncAttachmentUpload: (message: string) => `Attachment upload ${message}`,
    fncAttachmentButtonClick: `Clicked on 'Upload from your device' button.`,
    fncAttachmentTooltipClick: `Clicked on the attachment field tooltip`,
    fncContactMobile: (mobileNumber, message) => `Entered a ${message} number: ${mobileNumber}`,
    fncContactEmail: (email, message) => `Entered a ${message} email: ${email}`,
    fncSubmissionStatus: (message: string) => `Submission ${message}`,
    mobileServiceChangeRequestForm: 'mobile service change request form',
    mobileServiceListPage: 'mobile services: ',
    tempSuspensionPage: (serviceNumber: string) => `Temprorarily suspend page for ${serviceNumber}`,
    webForm: (webformName: string, serviceNumber: string) => `${webformName} form for ${serviceNumber}`,
    cancelTempSuspension: `clicked on cancel button`,
    continueToNoDiversionPopup: `clicked on continue to modal popup with no diversion number`,
    temporarilySuspend: `clicked on temporarily suspend button`,
    closeNoDiversionModal: `clicked on bo back on no diversion modal to close it`,
    temporarilySuspendWithNoDiversion: `clicked on temporarily suspend button on no diversion modal`,
    mobileServiceDetailPage: (mobileNumber: string) => `Mobile Service Detail Page for ${mobileNumber}`,
    connectionStatusRefresh: `clicked on refresh button for connection status change`,
    manageDropdownForTempSusp: `clicked on temporarily suspend option from manage dropdown`,
    billingAccountRoute: `clicked on billing account hyperlink from detail page`,
    reactivateServicePastDueDatePage: 'reactivate new service page for service past due date',
    cancelNewReactivateRequest: 'clicked on cancel button on reactivate new service page for service past due date',
    submitNewReactivateRequest: 'clicked on submit button on reactivate new service page for service past due date',
    ypsLandingPage: 'your products and services landing page',
    newBillingAccountTile: 'clicked on New billing account hyperling in mobile service list table',
    tempSuspensionErrorPage: (serviceNumber: string) =>
        `Error page for temporarily suspension form for ${serviceNumber}`,
    tryAgainForTempSusp: `clicked on try again button`,
    backToDetailPage: `clicked on back to service detail page`,
    serviceDetailsPageNavigation:  (serviceNumber: string) =>
        `mobile service detail page for ${serviceNumber} service number`,
    ypsBreadCrumbformobileServiceChangeRequestForm: (formName: string) =>
        `clicked on your products and services from ${formName} request form`,
    ypsBreadCrumbforServiceDetailPage: (serviceNumber: string) =>
        `clicked on your products and services from ${serviceNumber} detail page`,
    mobServiceBreadCrumbforServiceDetailPage: (serviceNumber: string) =>
        `clicked on mobile service List from ${serviceNumber} detail page`,
    dashboardBreadCrumbforWebForm: `clicked on dashboard from breadcrumb`,
    ypsBreadCrumbforWebForm: `clicked on YPS from breadcrumb`,
    mobileServiceBreadCrumbforWebForm: `clicked on Mobile Service list from breadcrumb`,
    serviceDetailBreadCrumbforWebForm: `clicked on Service Detail page from breadcrumb`,
    mobilitySolutionFromGeneralForm: (formName: string) =>
        `clicked on mobility solutions from ${formName} request form`,
    mxmMobileServicesGeneralFormBackButton: (formName: string) =>
        `clicked on back button from ${formName} request form.`,
    deactivationMobilePlansAndDevicesLink: (formName: string) =>
        `Clicked on mobile plans and devices link on ${formName} form`,
    mxmMobileServicesGeneralFormSubmitSuccessButton: (formName: string) =>
        `clicked on submit button from ${formName} request form with all mandatory questions filled`,
    mxmMobileServicesGeneralFormSubmitErrorButton: (formName: string) =>
        `clicked on submit button from ${formName} request form but got some validation error`,
    fncSubmissionResultPage: 'FNC Submission Result Page',
    ypsLandingPageComponent: 'YPS page: ',
    ypsLandingPageNiComponent: 'YPS: NI: Your products and services: ',
    nbnLandingPage: 'NBN Landing page',
    nbnTestType: (selectedTestType: string) => `Clicked on ${selectedTestType} Button`,
    nbnTestInitiated: (selectedID: string[]) => `Clicked continue button to initiate test on ${selectedID}`,
    nbnTestCreated: (selectedID: string, selectedTest: string) =>
        `Clicked on ${selectedTest} option to initiate test on ${selectedID}`,
    tabName: (tabName: string) =>  `user is on ${tabName} tab under all-requests`,
    allRequestsComponent: 'All Requests',
    ypsRequestCatalogueComponent: 'request catalogue component',
    nbnViewResults: 'Clicked View results link for nbn test',
    maximMobileServicesContextMenuClick: 'user clicked on mobile plans and devices context menu',
    ssmLink: 'Clicked on SSM link',
    reactivateMobileServiceForm: (selectedOption: string) =>
        `clicked on reactivate button to submit reactivate form with ${selectedOption} option.`,
    reactivateMobileServiceFormTryAgain: 'User clicked on Try again button on reactivate form error screen',
    reactivateMobileServiceFormNewRequest: 'User clicked on New request button on reactivate form error screen',
    nbnHistoryPage: (selectedId: string) => `Redirected to nbn history detail page for service ID ${selectedId}`,
    reactivateMobileServiceModal: 'Reactivation modal for deactivated service > 28 days',
    reactivationModalSubmitButton: 'Clicked submit request button on reactivation modal',
    reactivationModalCancelButton: 'Clicked cancel button on reactivation modal',
    adaptiveMobilityManageButton: 'clicked on adaptive mobility manage button on mobile plans and devices',
    nbnToastTracking: (description: string) => `Toast: ${description}`,
    sortingOnMobileServicesTable: (columnName: string, sortValue: string) =>
        `user clicked on ${columnName} to sort in ${sortValue} order`,
    maximActivitiesList: 'Maxim activities list page',
    srmUnifiedTrackListPage: 'Request tab in unified track/ ',
    srmUnifiedTrackListViewAllButtonClick: (buttonName: string) => `View all ${buttonName} button clicked`,
    srmUnifiedTrackListTableRowClick: (tableName: string) => `Clicked on ${tableName} row in unified track`,
    maximWebformForGeneralRequest: `maxim general requests webform`,
    simSerialActionButton: (buttonName: string) => `Clicked on ${buttonName} sim serial button`,
    mobileServiceDetailsPromptActionButton: (buttonName: string) =>
        `Clicked on ${buttonName} of navigation prompt`,
    submittedformName: (formName) => `${formName}: `,
    subFormNameWithRequestStatus: (subFormName: string,  status: string) => `submission ${status} for ${subFormName}`,
    actionOnRedirectionModal: (action: string) => `Clicked on ${action} button of redirection dialogue`,
    modifyDiversionButtonClick: (action?: string) => `${action ?
        'Clicked on modify diversion form button' : 'Clicked on go back button on modify diversion form'}`,
    manageButton: `clicked on manage button on details page in connection status block`,
    cancelConnectionStatusChange: `clicked on cancel button in connection status block to cancel operation`,
    nextButtonForConnectionStatusChange: `Clicked on next button to navigate to respective form
     in connection status block`,
    saveButtonForCallForwarding: `Clicked on save button to save the call forwarding change
     in connection status block`,
    confirmModifyDiversion: 'Clicked on confirm call forwarding.',
    continueClickName: (buttonName: string) =>
        `${buttonName}`,
    callStatusCreateButton: (webFormName: string) => `clicked on create a request button for ${webFormName}`,
    pukCode: (btnName: string) => `clicked on ${btnName} button of PUK code`,
    legacyETC: (btnName: string) => `clicked on ${btnName} button of ETC on legacy details page`,
    createRequestButtonClick: (blockName: string) => `${blockName} Create a request button clicked.`,
    anotherChangeCreateRequestButton: `clicked on create request button to make another change`,
    noResultFoundForSearchedNumber: 'Unable to find any results for searched mobile number.',
    mobilityRequestForm: 'mobility request form',
    mobileServiceFormSubmissionPageWithFormName: (formName) => `${formName} submission result page`,
    mobileServiceDetailsIntRoamShowDetailsLink: (buttonName) =>
        `Clicked on ${buttonName} details in international roaming section`,
    mobileServiceDetailsIntRoamLearnMoreLink: 'Clicked on Learn more in international roaming section',
    cancelLeavingTconnectModal: 'Clicked on cancel button of leaving tconnect modal popup',
    continueLeavingTconnectModal: 'Clicked on continue button of leaving tconnect modal popup',
    idd: (btnName: string) => `Clicked on ${btnName} button of International Calls`,
    apn: (btnName: string) => `Clicked on ${btnName} button of APN`,
    mms: (btnName: string) => `Clicked on ${btnName} button of MMS`,
    voicemail: (btnName: string) => `Clicked on ${btnName} button of Voicemail`,
    toggleButtonForIntRoam: (actionName: string) => `Clicked on toggle button for int roam to ${actionName} it`,
    intRoamEnableModal: (serviceNumber: string) => `Modal for enabling International Roaming for service
     ${serviceNumber}`,
    navigateToCustomerterms: `Clicked on customer terms link on enable int roam modal`,
    navigateToEligibleCountries: `Clicked on eligible countries link on enable int roam modal`,
    cancelButtonForClosingEnableIntRoamModal: `Clicked on Cancel button for enable int roam modal`,
    cancelButtonForClosingEnableMMSModal: `Clicked on Cancel button for enable MMS modal`,
    submitButtonForEnableIntRoamRequest: (requestType: string) => `Clicked on submit Button to raise ${requestType}
     request for enabling international roaming`,
    submitButtonForEnableMMSRequest: (requestType: string) => `Clicked on submit Button to raise ${requestType}
     request for enabling MMS`,
    intRoamDisableModal: (serviceNumber: string) => `Modal for disabling International Roaming for service
     ${serviceNumber}`,
    submitButtonForDisableIntRoamRequest: `Clicked on submit Button to disable international roaming`,
    cancelButtonForClosingDisableIntRoamModal: `Clicked on Cancel button for disable int roam modal`,
    mmsEnableModal: (serviceNumber: string) => `Modal for enabling MMS for service ${serviceNumber}`,
    createRequestButtonForIDD: (pageName: string) => `clicked on create a request button in IDD to go to ${pageName}`,
    messageBankEnableModal: (serviceNumber: string) => `Modal for enabling MessageBank for service ${serviceNumber}`,
    trackingRequestsComponent: 'Tracking-Requests',
    newTrackingRequestsComponent: 'Tracking-Requests-paginated',
    getSupport: 'Get-support',
    changeVoicemailOptionsPage: 'change adaptive mobility voicemail option catalogue form',
    tryAgainForVoicemail: 'clicked on try again for add-ons on adaptive mobility voicemail option catalogue',
    enableDisableIRMonthPassForm: 'Enable / disable international roaming month pass form',
    iddCatalogue: 'Add, modify or cancel an International Calls and SMS Pack catalogue',
    newTnowSuccessPage: 'new success page for tnow catalogue items',
    bddCatalogue: 'Enable / disable Business Demand Data catalogue',
    acceleratorAddOnPage: 'Enable / disable Accelerator add-on option catalogue form',
    manageDirectoryListingPage: 'Manage directory listing catalogue',
    changeAdaptiveMobilityPlanPage: 'Change Adaptive Mobility Plan catalogue',
    requestListPage: 'Request list page',
    relatedOrder: 'Related order link',
    requestPageInt: 'SSOFeature:Request'
});

export {
    ApplicationName,
    Links,
    Components
};
